<template>
    <div>
        <template v-if="!tiny">
            <strong>Toegewezen aan:</strong>
            <div class="mb-3">
                <div class="card assignee">
                    <div class="card-body d-flex justify-content-between align-content-center">
                        <div class="card-text">
                            {{lead.assignee ? lead.assignee.name : '-'}}
                        </div>
                        <button :for="_uid + '-form-view-employees' + lead.id" v-b-modal="_uid + '-form-view-employees' + lead.id" v-if="updateable" v-shortkey="{assignModel: ['t']}" @shortkey="keyDown" class="btn btn-sm btn-link">
                            <i class="fas fa-pencil-alt"></i>
                        </button>
                    </div>
                </div>
                <a class="text-primary force" v-if="updateable" @click="select('me')">Wijs mijzelf toe</a>
            </div>
        </template>

        <b-modal
                @show="onOpen"
                @shown="fieldFocus"
                @hidden="$root.modelOpen = false"
                :no-close-on-backdrop="true"
                :lazy="true"
                :ref="_uid + '-form-view-employees' + lead.id"
                :id="_uid + '-form-view-employees' + lead.id"
                title="Toewijzen aan"
                size="md"
                scrollable>
            <div>
                <input data-hj-whitelist ref="assigneeSearchField" class="form-control" type="search" v-model="q" placeholder="Naam" aria-label="Search" />

                <div class="detail-list mt-2">
                    <strong>Resultaten:</strong>
                    <div class="results">
                        <div class="list-group list-group-flush">

                            <a @click="select(result)" v-for="result in searchResults" class="list-group-item">

                                <div class="d-flex justify-content-between align-items-center text-sm-left">
                                    <div style="flex-grow: 10; flex-basis:0;">
                                        {{result.name ? result.name : '-'}}
                                    </div>
                                    <div>
                                        <i class="fas fa-chevron-right"></i>
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>

            </div>
            <div slot="modal-footer" class="w-100">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="text-muted">
                        <small v-if="loaded!==null">
                            <a class="refresh force" @click="refresh()"><em class="fa fa-sync"></em> <timeago :since="loaded":auto-update="30"></timeago> bijgewerkt</a>
                        </small>
                        <small v-if="loaded===null">
                            <em class="fa fa-sync fa-spin"></em> Bezig met ophalen van resultaten
                        </small>
                    </div>

                    <button class="btn btn-light float-right" @click="hide">
                        Annuleren
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        components: {

        },
        props: {
            lead: {
                type: Object,
                required: true,
            },
            updateable: {
                type: Boolean,
                default: false
            },
            tiny: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                results: [],
                loaded: null,
                errors: [],
                q: '',

                currentUserId: null
            }
        },
        computed: {
            currentUser() {
                if(!this.currentUserId) {
                    return null;
                }

                for(let index in this.results) {
                    if(!this.results.hasOwnProperty(index)) {
                        continue;
                    }
                    let user = this.results[index];

                    if(user.id === this.currentUserId) {
                        return user;
                    }
                }
            },
            searchResults() {
                let q = this.q;

                if(!q || q.length < 1) {
                    return this.results;
                }

                return window._.filter(this.results, function (row) {
                    if(!row || !row.hasOwnProperty('name')) {
                        return false;
                    }
                    return row.name.toLowerCase().includes(q.toLowerCase());
                });
            }
        },
        watch: {
            results() {
                this.$store.commit('usersStore/users', this.results);
            },
        },
        mounted() {
            let user = document.head.querySelector('meta[name="user-id"]');
            if (user) {
                this.currentUserId = parseInt(user.content);
            }

            if(this.$store.getters['usersStore/users'].length > 0) {
                this.results = this.$store.getters['usersStore/users'];
                this.loaded = new Date();
            }
        },
        methods: {
            hide() {
                this.q = '';
                this.$refs[this._uid + '-form-view-employees' + this.lead.id].hide();
            },
            refresh() {
                this.showing = null;
                this.loaded = null;
                this.errors = [];

                axios.get('/api/v1/leads/assignees')
                    .then(response => {
                        this.loaded = new Date();
                        this.results = response.data;
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
            select(user) {
                this.hide();
                let to = '';
                let url = user;
                if(user !== 'me') {
                    url = user.id;
                    to = ' aan '+ user.name
                }

                if(!this.lead.id) {
                    this.$emit('selected', this.currentUser);
                    return;
                }

                this.$swal({
                    title: 'Lead aan het toewijzen...',
                    showConfirmButton: false
                });
                this.$swal.showLoading();

                return axios.put('/api/v1/leads/form/' + this.lead.id + '/assign/' + url, {})
                    .then(response => {
                        this.$emit('updated', response.data);
                        this.$swal({
                            toast: true,
                            position: 'top',
                            type: 'success',
                            title: 'Lead is toegewezen'+to+'!',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                        this.show();
                    });
            },
            onOpen() {
                if(this.results.length === 0) {
                    this.refresh();
                }
            },
            keyDown(event) {
                switch (event.srcKey) {
                    case 'assignModel':
                        this.$refs[event.target.attributes.for.value].show();
                        this.$root.modelOpen = event.target.attributes.for.value;
                    break;
                }
            },
            fieldFocus() {
                this.$refs.assigneeSearchField.focus();
            }
        }
    }
</script>